import React from 'react'
import { FC, PropsWithChildren } from 'react'

function createContext<A>() {
    const context = React.createContext<A | undefined>(undefined)

    function useContext() {
        const c = React.useContext(context)
        if (!c) throw new Error('useContext must be inside a Provider with a value')
        return c
    }

    return [useContext, context.Provider] as const
}

export type PreviewContext = {
    previewAdId: number | undefined
}

export const [usePreviewCtx, PreviewProvider] = createContext<PreviewContext>()

export const PreviewContextProvider: FC<PropsWithChildren<PreviewContext>> = ({ previewAdId, children }) =>
    <PreviewProvider value={{ previewAdId: previewAdId }}>{children}</PreviewProvider>
